export function setLocalStorage(storage, key, value, access) {
  if (access) {
    try { storage.setItem(key, value); } catch (e) {}
  }
  return value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/setLocalStorage.js
// module id = null
// module chunks = 